var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vista && _vm.vista.config.legales)?_c('div',{staticClass:"legales-container"},[_c('div',{staticClass:"legales-container--content",domProps:{"innerHTML":_vm._s(_vm.vista.config.legales)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }